var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphicR = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 390,
  height: 162,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#ECD8FB",
  clipPath: "url(#graphic-r_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.41 115.453h895.18a1.41 1.41 0 1 1 0 2.818H1.41a1.409 1.409 0 1 1 0-2.818M63.899 39.736h625.335a1.41 1.41 0 1 1 0 2.818H63.899a1.409 1.409 0 1 1 0-2.818M96.52 0h592.714a1.41 1.41 0 1 1 0 2.818H96.519a1.41 1.41 0 1 1 0-2.818M175.705 77.595H896.59a1.41 1.41 0 1 1 0 2.818H175.705a1.41 1.41 0 1 1 0-2.818"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "graphic-r_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M898 449H0V0h898z"
})))));
export { SvgGraphicR as ReactComponent };
export default __webpack_public_path__ + "260106fe059194b883c05cb99da88b28.svg";